import React, { useState, createContext, useContext } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import AlertModal from './AlertModal'

const AlertModalContext = createContext()

function useAlertModal(){

    const alertTypes = {
        SUCCESS: "SUCCESS",
        WARNING: "WARNING",
        EXTREME: "EXTREME",
        ERROR: "ERROR",
        QUESTION: "QUESTION"
    }

    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.alert

    const [isShow, setIsShow] = useState(false)
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [alertType, setAlertType] = useState(alertTypes.WARNING)
    const [button, setButton] = useState([
        {
            title: "OK",
            variant: "primary",
            onClick: ()=>{ setIsShow(false) }
        },
        {
            title: "Cancel",
            variant: "secondary",
            onClick: ()=>{ setIsShow(false) }
        }
    ])



    return { 
        isShow, title, description, alertType, button,
        setIsShow, setTitle, setDescription, setAlertType, setButton
    }
}

function AlertModalProvider({ children }){
    const alertModal = useAlertModal()

    return(
        <AlertModalContext.Provider value={alertModal}>
            <AlertModal
            title={alertModal.title}
            description={alertModal.description}
            alertType={alertModal.alertType}
            button={alertModal.button}
            isShow={alertModal.isShow}
            />
            {children}
        </AlertModalContext.Provider>
    )
}

export { AlertModalContext, AlertModalProvider }
